/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
    name: "PhaseModal",
    components: { customModal },

    props: {
        editingId: {
            type: String,
            default: null
        }
    },

    emits: ["closeModal", "saved"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",

            studyId: "",
            studyversion: "",

            phase: {
                name: "",
                type: "",
                active: true
            },

            isEditMode: false,
            loading: false,

            errors: {
                name: false,
                type: false
            },

            errorMessages: {
                name: "",
                type: ""
            }
        };
    },

    async mounted() {
        this.token = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        await this.getstudyversion();
        console.log("Editing ID:", this.editingId);

        if (this.editingId) {
            this.isEditMode = true;
            await this.fetchPhaseById();
        }
    },

    methods: {

        clearErrors() {
            this.errors.name = false;
            this.errors.type = false;
            this.errorMessages.name = "";
            this.errorMessages.type = "";
        },

        validate() {
            this.clearErrors();
            let isValid = true;

            if (!this.phase.name || !this.phase.name.trim()) {
                this.errors.name = true;
                this.errorMessages.name = "Please enter phase name";
                isValid = false;
            }


            return isValid;
        },
        clearError() {
            this.errors.name = false;
            this.errorMessages.name = "";
        },
        async getstudyversion() {
            try {
                const currentstudy = store.getters.getStudyIs;
                this.idToken = store.getters.getIdToken;

                const response = await axios.get(`${this.baseurl}/management/study/studyversionlist?studyId=${currentstudy}&isActive=true`, {
                    headers: {
                        Authorization: "Bearer " + this.idToken,
                        "Content-Type": "application/json"
                    }
                });


                this.studyversion = response.data[0] || "";

            } catch (error) {
                console.error("Error fetching studyversion:", error);
            }
        },

        async fetchPhaseById() {
            try {
                this.loading = true;

                const response = await axios.get(
                    `${this.baseurl}/management/studyphase/getstudyphasebyid?phaseId=${this.editingId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token
                        }
                    }
                );

                const data = response.data;

                this.phase = {
                    name: data.name || "",
                    type: data.type || "",
                    active: data.active !== null && data.active !== undefined ? data.active : true
                };

            } catch (err) {
                console.error(err);
                alert("Failed to load phase data");
            } finally {
                this.loading = false;
            }
        },

        async submitPhase() {
            if (!this.validate()) return;

            try {
                if (this.isEditMode) {

                    const payload = {
                        studyPhaseId: this.editingId,
                        studyId: this.studyId,
                        name: this.phase.name,
                        type: this.phase.type,
                        active: this.phase.active
                    };

                    await axios.put(
                        `${this.baseurl}/management/studyphase/updatestudyphase`,
                        payload,
                        {
                            headers: {
                                Authorization: "Bearer " + this.token
                            }
                        }
                    );

                    alert("Phase updated successfully");

                } else {

                    const payload = {
                        name: this.phase.name,
                        studyId: this.studyId,
                        studyVersion: this.studyversion,
                        type: this.phase.type,
                        active: this.phase.active
                    };

                    await axios.post(
                        `${this.baseurl}/management/studyphase/createstudyphase`,
                        payload,
                        {
                            headers: {
                                Authorization: "Bearer " + this.token
                            }
                        }
                    );

                    alert("Phase created successfully");
                }

                this.$emit("saved");
                this.closeModal();

            } catch (err) {
                console.error(err);
                alert(err.response?.data?.detail || "Save failed");
            }
        },

        closeModal() {
            this.$emit("closeModal");
        },


    }
};